import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const selectItem = createAction('selectItem');
export const toggleDetails = createAction('toggleDetails');
export const setListLoading = createAction('setListLoading');
export const deleteItemRequest = createAction('deleteItemRequest');
export const deleteItemSuccess = createAction('deleteItemSuccess');
export const getItemListRequest = createAction('getItemListRequest');
export const getItemListSuccess = createAction('getItemListSuccess');
export const exportTrailersRequest = createAction('exportTrailersRequest');
export const createTrailerActivityListRequest = createAction('createTrailerActivityListRequest');
export const createTrailerActivityListSuccess = createAction('createTrailerActivityListSuccess');
export const synchronizeTrailerActivityRequest = createAction('synchronizeTrailerActivityRequest');
// details
export const selectTrailer = createAction('selectTrailer');
export const deleteTrailersRequest = createAction('deleteTrailersRequest');
export const getDetailsByRowGuidRequest = createAction('getDetailsByRowGuidRequest');
export const getDetailsByRowGuidSuccess = createAction('getDetailsByRowGuidSuccess');
export const updateTrailerCommentsRequest = createAction('updateTrailerCommentsRequest');
export const updateTrailerCommentsSuccess = createAction('updateTrailerCommentsSuccess');
export const resetTrailerActivityListDetails = createAction('resetTrailerActivityListDetails');
export const addTrailersToActivityListRequest = createAction('addTrailersToActivityListRequest');
export const addTrailersToActivityListSuccess = createAction('addTrailersToActivityListSuccess');
export const updateTrailerActivityListRequest = createAction('updateTrailerActivityListRequest');
export const updateTrailerActivityListSuccess = createAction('updateTrailerActivityListSuccess');
